/**
 * One rule for "the platform did not send this metric" wherever a Result reads
 * a FactRow (rules-04 C1): D1's boxes 3, 9 and 13, and D3 through one row per
 * creative; box 13 applies the reach half to each campaign too. NULL is not
 * sent; so is a reach the platform cannot send, though the writers store it as 0
 * (reachNotSent, in the leaf services/platformReach). Pure.
 *
 * @module services/overview/reportedMetric
 */
import { reachNotSent } from '@/services/platformReach';
import type { ResultMetric } from '@/services/targets/resultMetric';
import type { FactRow } from './overviewTypes';

/** The row's value for `metric`, or null when the platform did not send it (reachNotSent). Every other metric is the row's own. */
export const metricValueOf = (row: FactRow, metric: ResultMetric): number | null => {
  if (metric !== 'reach') return row[metric];
  return reachNotSent(row.platform, row.reach, row.impressions) ? null : row.reach;
};
